import { useEffect } from "react";

const PaginationCustom = (props) => {

  const { currentRefinement, nbPages, handlePageUpdate, router, defaultRefinement } = props

  useEffect(() => {

    if(defaultRefinement !== currentRefinement) {
  
      let pages = {...router.query}
      delete pages.pages
      delete pages.page
      if(router.query?.pages) {
        router.push({pathname: router.query.pages.join('/'), query: {...pages}})
      } else {
        router.push({query: {...pages}})
      }
    }
  },[currentRefinement])
  let startIndex = defaultRefinement - 3 > 0 ? defaultRefinement - 3 : 1
  if(currentRefinement + 3 >= nbPages) {

    startIndex = nbPages - 6
  }
  return (
    nbPages == 1 ?  <div className="padding-block"></div> : 
    nbPages !== 0  &&
    <div className="ais-Pagination">
      <ul className="ais-Pagination-list">
        <li className={`ais-Pagination-item ais-Pagination-item--firstPage ${currentRefinement === 1 ? 'ais-Pagination-item--disabled' : ''}`}>
          <a
            className="ais-Pagination-link"
            href={`/page=1`}
            aria-label={`First page`}
            onClick={event => {
              event.preventDefault();
              handlePageUpdate(1, router)
            }}>
            «
          </a>
        </li>
        <li className={`ais-Pagination-item ais-Pagination-item--previousPage ${currentRefinement === 1 ? 'ais-Pagination-item--disabled' : ''}`}>
          <a
            className="ais-Pagination-link"
            href={`/page=${currentRefinement - 1}`}
            aria-label={`Previous page`}
            onClick={event => {
              event.preventDefault();
              currentRefinement !== 1 && handlePageUpdate(currentRefinement - 1, router)
            }}>
            Prev
          </a>
        </li>
        {new Array(7).fill(null).map((_, index) => {
          let page = defaultRefinement ? startIndex + index : index + 1;
          return ( page > 0 && nbPages >= page &&
            <li key={index} className="ais-Pagination-item">
              <a
                href={`/page=${page}`}
                aria-label={`Page ${page}`}
                className={`${currentRefinement === page ? 'ais-Pagination-link--selected' : ''}`}
                onClick={event => {
                  event.preventDefault();
                  handlePageUpdate(page, router)
                }}
              >
                {page}
              </a>
            </li>
          );
        })}
        <li className={`ais-Pagination-item ais-Pagination-item--nextPage ${(nbPages === currentRefinement || nbPages === 0) ? 'ais-Pagination-item--disabled' : ''}`}>
          <a
            className="ais-Pagination-link"
            href={`/page=${currentRefinement + 1}`}
            aria-label={`Next page`}
            onClick={event => {
              event.preventDefault();
              (!(nbPages === currentRefinement || nbPages === 0)) && handlePageUpdate(currentRefinement + 1, router)
            }}>
            Next
          </a>
        </li>
        <li className={`ais-Pagination-item ais-Pagination-item--lastPage ${(nbPages === currentRefinement || nbPages === 0) ? 'ais-Pagination-item--disabled' : ''}`}>
          <a
            className="ais-Pagination-link"
            href={`/page=${nbPages}`}
            aria-label={`Last page`}
            onClick={event => {
              event.preventDefault();
              handlePageUpdate(nbPages, router)
            }}>
            »
          </a>
        </li>
      </ul>
    </div>
  )
};

export default PaginationCustom
